<div class="pdf-native-wrapper">
    <div class="pdf-loading" *ngIf="isLoading">
        <div class="pdf-spinner"></div>
        <span>Đang tải nội dung quy chế…</span>
    </div>

    <div class="pdf-error" *ngIf="error">
        ⚠️ {{ error }}
    </div>

    <div class="pdf-clean-container" #canvasContainer *ngIf="!isLoading && !error"></div>
</div>